<template>
<div class="filter-content">
  <span>
    <v-menu
      content-class="menu-filter-content"
      :close-on-content-click="false"
      max-height="700px"
      min-width="300px"
      offset-y
    >
      <template v-slot:activator="{ on : menu }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on : tooltip }">
            <v-btn
              dark
              color="orange"
              v-on="{ ...tooltip, ...menu }"
            >
            <v-icon>filter_list</v-icon>
            </v-btn>
          </template>
          <span>Фильтр</span>
        </v-tooltip>

      </template>
      <v-list class="filter-menu" @keyup.native.enter="goFilter">
        <v-list-item dense>
          <span class="filter-buttons filter-text">
            Фильтр
          </span>
          <v-spacer></v-spacer>
          <span class="filter-buttons filter-text">
            {{ count }} / {{ countTotal }}
          </span>
        </v-list-item>

        <!-- fields -->
        <v-list-item>
          <v-text-field
            v-model="query.user__username__icontains"
            label="Логин (эл. почта)"
            hide-details
          ></v-text-field>
        </v-list-item>

        <v-list-item>
          <v-text-field
            v-model="query.user__last_name__icontains"
            label="Фамилия"
            hide-details
          ></v-text-field>
        </v-list-item>

        <v-list-item>
         <v-autocomplete
           :items="items.roles"
           v-model="query.user__roles"
           label="Роли"
           item-value="id"
           item-text="name"
           autocomplete
           hide-details
           no-data-text="Нет результатов"
         ></v-autocomplete>
         </v-list-item>

        <v-list-item>
         <v-autocomplete
           :items="items.divisions"
           v-model="query.division"
           label="Адм. подразделение"
           item-value="id"
           item-text="name"
           autocomplete
           hide-details
           no-data-text="Нет результатов"
         ></v-autocomplete>
         </v-list-item>

        <v-list-item>
         <v-autocomplete
           :items="items.positions"
           v-model="query.position"
           label="Должность"
           item-value="id"
           item-text="name"
           autocomplete
           hide-details
           no-data-text="Нет результатов"
         ></v-autocomplete>
         </v-list-item>

        <v-list-item>
          <v-checkbox
            v-model="query.user__is_active"
            label="Активен"
            hide-details
          ></v-checkbox>
         </v-list-item>

         <!-- fields -->
        <v-list-item>
          <v-spacer></v-spacer>
          <span class="filter-buttons">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  color="orange"
                  v-on="on"
                  @click="resetFilter"
                >
                <i class="fas fa-ban fa-lg"></i>
                </v-btn>
              </template>
              <span>Сбросить</span>
            </v-tooltip>
          </span>

          <span class="filter-buttons">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  :loading="filterPending"
                  dark
                  color="orange"
                  v-on="on"
                  @click="goFilter"
                >
                <i class="fas fa-search fa-lg"></i>
                </v-btn>
              </template>
              <span>Поиск</span>
            </v-tooltip>
          </span>
        </v-list-item>
      </v-list>
    </v-menu>
  </span>
</div>
</template>

<script>
import { removeNulls } from '@/utils'
import FilterMixin from '@/components/filters/Filter.vue'

export default {
  mixins: [FilterMixin],
  props: {
    initialQuery: {
      type: Object,
      default: function () {
        return {
          name__icontains: '',
          date_created__gte_menu: null,
          date_created__lte_menu: null,
          date_created__gte: null,
          date_created__lte: null
        }
      }
    }
  },
  data: function () {
    return {
      // refs
      items: {
        roles: [],
        positions: [],
        divisions: []
      },
      refs: [
        { url: 'roles/', name: 'roles' },
        { url: 'ref/divisions/', name: 'divisions' },
        { url: 'ref/positions/', name: 'positions' },
      ],
    }
  },
}
</script>
<style scoped>
</style>
